"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UILogger = exports.PiiLevelEnum = exports.LogLevel = void 0;
var browserBunyan = __importStar(require("browser-bunyan"));
var axios_1 = __importDefault(require("axios"));
var base_logger_1 = require("./base-logger");
var ui_stream_1 = require("./stream/ui-stream");
var logger_utils_1 = require("./utils/logger-utils");
__exportStar(require("./interfaces/LoggerObjects"), exports);
var LogLevel_1 = require("./enums/LogLevel");
Object.defineProperty(exports, "LogLevel", { enumerable: true, get: function () { return LogLevel_1.LogLevel; } });
__exportStar(require("./enums/Environment"), exports);
__exportStar(require("./enums/Category"), exports);
var SecurityConfig_1 = require("./interfaces/SecurityConfig");
Object.defineProperty(exports, "PiiLevelEnum", { enumerable: true, get: function () { return SecurityConfig_1.PiiLevelEnum; } });
var UILogger = (function (_super) {
    __extends(UILogger, _super);
    function UILogger(config) {
        var _this = _super.call(this) || this;
        _super.prototype.initHandler.call(_this, config, _this.initCallback.bind(_this));
        return _this;
    }
    UILogger.prototype.initCallback = function (config) {
        this.stream = new ui_stream_1.UIStream(config);
    };
    UILogger.prototype.assignHavenUILoggerProperties = function (log) {
        var _this = this;
        log.mapToErrorLog = function (errData) {
            return logger_utils_1.LoggerUtils.mapToErrorLog(errData);
        };
        log.childLogger = function (rootValues, dataValues) {
            var childLogger = logger_utils_1.LoggerUtils.initializeChildLogger(log, rootValues, dataValues);
            _this.assignHavenUILoggerProperties(childLogger);
            return childLogger;
        };
        logger_utils_1.LoggerUtils.applyOverridesToLogLevelFunctions(log);
    };
    UILogger.prototype.getSystemLogger = function () {
        var log = this.getUIBunyanLogger();
        this.assignHavenUILoggerProperties(log);
        return log;
    };
    UILogger.prototype.getUIBunyanLogger = function () {
        var streams = this.stream.getStreams();
        var log = browserBunyan.createLogger({
            name: this.config.app,
            level: this.config.level,
            streams: streams
        });
        return log;
    };
    UILogger.getUILogConfig = function (serverURL) {
        return __awaiter(this, void 0, void 0, function () {
            var result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, axios_1.default.get(serverURL + '/uiLogConfig')];
                    case 1:
                        result = _a.sent();
                        return [2, result.data];
                    case 2:
                        err_1 = _a.sent();
                        throw new Error('get ui log config err: ' + err_1.message);
                    case 3: return [2];
                }
            });
        });
    };
    return UILogger;
}(base_logger_1.BaseLogger));
exports.UILogger = UILogger;
//# sourceMappingURL=ui-logger.js.map